import { connectScopedPreauthorizationOption } from './connectPreauthorizationOption';
import { PreauthorizationOption as PreauthorizationOptionPure } from './PreauthorizationOption';

export const PreauthorizationOption = connectScopedPreauthorizationOption(PreauthorizationOptionPure);
